import React from 'react';
import { IconProps } from './icons.models';

const CopyLinkIcon: React.FC<IconProps> = ({
    width = 13,
    height = 16,
    className,
    onClick,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.70285 2.79688H1.2648C0.566865 2.79688 0 3.36374 0 4.06167V14.7338C0 15.4317 0.566865 15.9986 1.2648 15.9986H8.70285C9.40078 15.9986 9.96764 15.4317 9.96764 14.7338V4.06167C9.96437 3.36374 9.3975 2.79688 8.70285 2.79688ZM9.07967 14.7305C9.07967 14.9402 8.90928 15.1106 8.69957 15.1106H1.26152C1.05181 15.1106 0.881425 14.9402 0.881425 14.7305V4.06167C0.881425 3.85196 1.05181 3.68158 1.26152 3.68158H8.69957C8.90928 3.68158 9.07967 3.85196 9.07967 4.06167V14.7305Z" fill="#3EAE54" />
            <path d="M11.5471 0H4.10903C3.4111 0 2.84424 0.566865 2.84424 1.2648C2.84424 1.51055 3.04084 1.70715 3.28659 1.70715C3.53234 1.70715 3.72894 1.51055 3.72894 1.2648C3.72894 1.05509 3.89933 0.884702 4.10903 0.884702H11.5471C11.7568 0.884702 11.9272 1.05509 11.9272 1.2648V11.9369C11.9272 12.1466 11.7568 12.317 11.5471 12.317C11.3013 12.317 11.1047 12.5136 11.1047 12.7594C11.1047 13.0051 11.3013 13.2017 11.5471 13.2017C12.245 13.2017 12.8119 12.6349 12.8119 11.9369V1.2648C12.8119 0.566865 12.245 0 11.5471 0Z" fill="#3EAE54" />
        </svg>
    );
};

export default CopyLinkIcon;


